import Vue from 'vue';
import axios from 'axios';
import router from "@/router";
import store from "@/store";


const axiosIns = axios.create({
  baseURL: process.env.VUE_APP_API,
  withCredentials: true,
})

// axiosIns.interceptors.request.use(function (config) {
//   return config;
// });
axiosIns.interceptors.response.use(response => {
  return response;
},  error => {
  if (error.response.status === 401) {
    Vue.$cookies.remove("token");
    store.commit('user/UPDATE_USER_DATA', null);
     router.push('/login').catch(() => {})
  }
  return Promise.reject(error);
});

export default axiosIns
